import { JsiSkApi } from "./web";

export const Skia = JsiSkApi(global.CanvasKit);
